import { BaseModel } from 'sjs-base-model';

export default class AddCustomerModel extends BaseModel {
  response = null;
  message = '';
  statusCode = null;
  sessionID = null;
  customerCode = null;
  oto = null;
  custcode = null;
  cellNo = null;
  flag = null;
  errorCode = null;
  description = null;
  isKYCEnabled = null;
  listOfValues = null;
  langcode = null;
  langShortCode = null;

  /*
   * Client-Side properties (Not from API)
   */
  // noneApiProperties = null;

  constructor(data) {
    super();

    this.update(data);
  }
}
